'use strict';

const jQuery = require('jquery');

const zone = require('./../../../services/structure/zone');
const ContentRepository = require('./../repository/ContentRepository');
const ContentManager = require('./../component/ContentManager');
const DefinitionManager = require('./../component/DefinitionManager');
const SaveManager = require('./../component/SaveManager');
const Notifier = require('./../../../services/notifier');
const Translator = require('./../../../core/translator');
const Mediator = require('./../../../core/mediator');

const contentListTpl = require('./template/content_list.hbs');

module.exports.onClick = function() {
    ContentRepository.findCategories().done(function(categories) {
        let toolbar = jQuery(contentListTpl({
            'categories': categories,
        }));

        toolbar.find('.cloud-content-list li .btn').publish('content:add');

        zone.setSmallPanel(Translator.translate('contents_list'), toolbar);
    });
};

module.exports.onAdd = function(object) {
    let event = object.event;
    let $currentTarget = jQuery(event.currentTarget);
    let type = $currentTarget.data('type');
    let rootContentSet = ContentManager.getRootContentSet();
    let dataEvent;

    if (type) {
        dataEvent = {
            'type': type,
        };

        dataEvent.definition = DefinitionManager.get(type);

        Mediator.publish('before:' + type + ':add', dataEvent);
        Mediator.publish('before:content:add', dataEvent);

        ContentManager.createElementWithSub('ColContentSet', type).done(function(colContentSet, content) {
            ContentManager.createElement('CloudContentSet', {
                'elements': [
                    {
                        'type': colContentSet.type,
                        'uid': colContentSet.uid,
                    },
                ],
            }).done(function(cloudContentSet) {
                cloudContentSet.getHtml().done(function($html) {
                    content.$ = $html.find('[data-bb-identifier^="' + content.type + '"]');
                    rootContentSet.$.append($html);

                    rootContentSet.setUpdated(true);

                    SaveManager.save();

                    Mediator.publish('after:' + type + ':add', content);
                    Mediator.publish('after:content:add', content);

                    content.addClass('cloud-highlight-content');

                    Notifier.success(Translator.translate('content_added'));
                });
            });
        });
    }
};
